// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3343":"f6f315fe","5842":"f6f315fe"}[chunkId] + ".chunk.css";
};